import { render } from "./DiscoveryVideos.vue?vue&type=template&id=7c69c12a&scoped=true"
import script from "./DiscoveryVideos.vue?vue&type=script&lang=js"
export * from "./DiscoveryVideos.vue?vue&type=script&lang=js"

import "./DiscoveryVideos.vue?vue&type=style&index=0&id=7c69c12a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c69c12a"]])

export default __exports__